import React, { useRef, useState } from "react";
import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import "./CarrierContactTable.scss";
import CarrierContactForm from "./CarrierContactForm";
import { process } from "@progress/kendo-data-query";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { addEditDeleteCarrierContactTableRow } from "./CarrierContactService";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect } from "react";
import { useFormValue } from "./FormContext";
import {
  ExcelExport,
  ExcelExportColumn,
} from "@progress/kendo-react-excel-export";

function CarrierContactTable({ tableData, ddData, onSearchClick }) {
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 10,
  });
  const [result, setResult] = useState(
    process(
      tableData.map((dataItem) => Object.assign({ selected: false }, dataItem)),
      dataState
    )
  );
  const [openForm, setOpenForm] = useState(false);
  const [editItem, setEditItem] = useState(false);
  const [visibleDialog, setVisibleDialog] = useState(false);
  const formRegionValue = useFormValue();
  let _export = useRef(null);
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;
  const hideButtons = MDADMIN === "False" && MDVIEWER === "True" ? true : false;

  useEffect(() => {
    setResult(
      process(
        tableData.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        dataState
      )
    );
  }, [tableData]);

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(
      process(
        tableData.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        event.dataState
      )
    );
  };

  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem({ ...item, type: "edit" });
  };

  const handleCancelEdit = () => {
    setOpenForm(false);
  };

  const handleSubmit = async (submitEvent) => {
    console.log({ submitEvent });
    if (formRegionValue.region === null) {
      toast.error("Please select Region Mode",{theme:"colored"});
      return;
    }
    setOpenForm(false);
    if (submitEvent["type"] === "add") {
      const payloadData = {
        ...submitEvent,
        opsGrp: submitEvent.opsGrp.opsGrp,
        geo: formRegionValue.region.geo,
        country: submitEvent.country.countryCode,
        scacd: submitEvent.scacd.text,
        carrier: submitEvent.scacd.value,
        modeTransport: submitEvent.modeTransport.value,
        id: "",
      };
      const response = await addEditDeleteCarrierContactTableRow({
        action: "ADD",
        dataList: [{ ...payloadData }],
      });
      if (response[0]["message"] === "Successfully inserted") {
        toast.success("Carrier Inserted Successfully ",{theme:"colored"});
        onSearchClick([{ opsGrp: "", geo: "", carrier: "", country: "" }]);
        setDataState({ skip: 0, take: 10 });
      } else {
        toast.error("Error While Inserting Carrier",{theme:"colored"});
      }
    } else {
      const response = await addEditDeleteCarrierContactTableRow({
        action: "EDT",
        dataList: [{ ...submitEvent }],
      });
      if (response[0]["message"] === "Successfully updated") {
        toast.success("Carrier Edited Successfully",{theme:"colored"});
        onSearchClick([{ opsGrp: "", geo: "", carrier: "", country: "" }]);
        setDataState({ skip: 0, take: 10 });
      } else {
        toast.error("Error While Deleting Carrier",{theme:"colored"});
      }
    }
  };

  const addRecord = () => {
    const item = {
      type: "add",
    };
    setOpenForm(true);
    setEditItem(item);
  };

  const toggleDialog = (props) => {
    if (
      result["data"].findIndex((dataItem) => dataItem["selected"] === true) ===
      -1
    ) {
      toast.error("Nothing to delete",{theme:"colored"});
      return;
    }
    setVisibleDialog(!visibleDialog);
  };

  const deleteRow = async () => {
    setVisibleDialog(!visibleDialog);
    const itemDeleteRow = result["data"].filter(
      (dataItem) => dataItem["selected"] === true
    );

    const response = await addEditDeleteCarrierContactTableRow({
      action: "DEL",
      dataList: itemDeleteRow,
    });
    response.forEach((res, i, arr) => {
      if (res["message"] === "Successfully deleted") {
        toast.success(
          `Carrier with scac id ${res["scacd"]} Deleted Successfully`,{theme:"colored"}
        );
      } else {
        toast.error(`Error While Deleting Carrier ${res["carrier"]}`,{theme:"colored"});
      }
    });
    onSearchClick([{ opsGrp: "", geo: "", carrier: "", country: "" }]);
    setDataState({ skip: 0, take: 10 });
  };

  const selectionChange = (event) => {
    const data = result.data.map((item) => {
      if (item.id === event.dataItem.id) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    setResult({ ...result, data });
  };

  const headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = result.data.map((item) => {
      item.selected = checked;
      return item;
    });
    setResult({ ...result, data });
  };

  const getFileName = () => {
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, "0");
    var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
    var yyyy = today.getFullYear();

    today = dd + "/" + mm + "/" + yyyy;
    return `Carrier_Contact_${today}`;
  };

  const fileName = getFileName();

  const exportExcel = () => {
    console.log(tableData)
    _export.save(tableData);
  };

  return (
    <>
      {
        <div className="tableStyle carrier-contact-table">
          <ExcelExport
            fileName={fileName}
            ref={(exporter) => (_export = exporter)}
          >
            <ExcelExportColumn field="opsGrp" />
            <ExcelExportColumn field="modeTransport" />
            <ExcelExportColumn field="geo" />
            <ExcelExportColumn field="country" />
            <ExcelExportColumn field="scacd" />
            <ExcelExportColumn field="contactName" />
            <ExcelExportColumn field="contactEmail" />
            <ExcelExportColumn field="contactPhone" />
          </ExcelExport>
          <Grid
            ScrollMode="scrollable"
            style={{ height: "600px", width: 'auto'}}
            data={result}
            pageable
            total={result.length}
            filterable
            onDataStateChange={onDataStateChange}
            reorderable
            selectedField="selected"
            onSelectionChange={selectionChange}
            onHeaderSelectionChange={headerSelectionChange}
            {...dataState}
          >
            <GridToolbar>
              <div>
                {!hideButtons && (
                  <>
                    <button className="btn k-button k-button-icontext" onClick={addRecord}>
                  Add new
                </button>
                    <button
                    className="btn k-button k-button-icontext rejectbtn"
                  onClick={toggleDialog}
                  style={{marginRight:'6px',marginLeft:"6px"}}
                    >
                      Delete
                    </button>
                  </>
                )}
                <button
                   className="btn k-button k-button-icontext"
                  title="Export Excel"
                  onClick={exportExcel}
                >
                  Export to Excel
                </button>
              </div>
            </GridToolbar>
            <Column
              field="selected"
              width="50px"
              filterable={false}
              headerSelectionValue={
                result.data.findIndex(
                  (dataItem) => dataItem.selected === false
                ) === -1
              }
            />
            <Column
              cell={MyEditCommandCell}
              width="70px"
              headerCell={() => <span><b>Edit</b></span>}
              filterable={false}
            />
            <Column
              field="opsGrp"
              headerCell={() => (
                <span>
                  <b>OPS Segment</b> <em>*</em>
                </span>
              )}
              width="140px"
            />
            <Column
              field="modeTransport"
              headerCell={() => (
                <span>
                  <b>Transportation Mode</b> <em>*</em>
                </span>
              )}
              width="140px"
            />
            <Column
              field="geo"
              headerCell={() => (
                <span>
                 <b>Region</b> <em>*</em>
                </span>
              )}
              width="90px"
            />
            <Column
              field="country"
              headerCell={() => (
                <span>
                  <b>Country Code</b> <em>*</em>
                </span>
              )}
              width="100px"
            />
            <Column
              field="scacd"
              headerCell={() => (
                <span>
                  <b>SCAC</b> <em>*</em>
                </span>
              )}
              width="90px"
            />
            <Column
              field="contactName"
              headerCell={() => (
                <span>
                  <b>Contact Name</b> <em>*</em>
                </span>
              )}
              width="160px"
            />
            <Column
              field="contactEmail"
              headerCell={() => (
                <span>
                 <b>Carrier EmailID</b> <em>*</em>
                </span>
              )}
            />
            <Column
              field="contactPhone"
              width="200px"
              headerCell={() => (
                <span>
                 <b>Carrier PhoneNo</b>  <em>*</em>
                </span>
              )}
            />
          </Grid>
          {openForm && (
            <CarrierContactForm
              cancelEdit={handleCancelEdit}
              onSubmit={handleSubmit}
              item={editItem}
              ddData={ddData}
            />
          )}
          {/* <div>
            <pre>{JSON.stringify(result, null, 2)}</pre>
          </div> */}
        </div>
      }
      {visibleDialog && (
        <Dialog title={"Confirm Carrier Delete"} onClose={toggleDialog}>
          <p style={{ margin: "25px", textAlign: "center" }}>
            Are you absolutely sure you want to delete?
          </p>
          <DialogActionsBar>
            <button className="k-button" onClick={deleteRow}>
              DELETE
            </button>
            <button className="k-button k-gray" onClick={toggleDialog}>
              CANCEL
            </button>
          </DialogActionsBar>
        </Dialog>
      )}
      {/* <ToastContainer position="top-right" autoClose={5000} /> */}
    </>
  );
}

export default CarrierContactTable;

const EditCommandCell = (props) => {
  const { ROLE_LIST } = JSON.parse(sessionStorage.getItem("profile"));
  const { MDADMIN, MDVIEWER } = ROLE_LIST;
  const hideButtons = MDADMIN === "False" && MDVIEWER === "True" ? true : false;

  return (
    <td>
      {!hideButtons && (
        <span onClick={() => props.enterEdit(props.dataItem)} class="k-icon k-i-pencil" style={{"cursor":"pointer"}}></span>
      )}
    </td>
  );
};
